import React, { useState, useEffect } from 'react';

import Switch from 'react-ios-switch';

export function Toggle() {
    const [checked, setChecked] = useState(false);
    // Simple usage
    return (<Switch checked={checked} onChange={setChecked} />)
}